import { get } from 'lodash'
import { useEffect, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import messages from '@/components/Form/AudienceTargeting/messages'
import { newFilter } from '@/components/Form/AudienceTargeting/utils'
import withField from '@/components/Form/FieldWrappers/old/withField'
import withFieldArray from '@/components/Form/FieldWrappers/withFieldArray'
import { RemoveCircle } from '@/components/Icons'

import AddFilter from './AddFilter'
import Filter from './Filter'

/**
 * Fake component to set custom field value without rerendering nested components
 */
const ScimExpression = withField(({ filters, setFieldValue, name }: any) => {
  useEffect(() => {
    if (filters) {
      const expressions = filters.reduce((prev: any, filter: any) => {
        const filterValue = get(filter, 'scimExpression.value')
        if (filterValue) return [...prev, filterValue]
        else return prev
      }, [])
      setFieldValue(name, {
        type: 'filter',
        value: expressions.join(' and ')
      })
    }
  }, [name, filters, setFieldValue])

  return null
})

const Audience = ({ name, value, firstFilterMandatory, readOnly = false, variables }: any) => {
  const filters = get(value, 'filters')
  return useMemo(
    () => (
      <div className="audience-container">
        <Filters
          name={`${name}.filters`}
          variables={variables}
          firstFilterMandatory={firstFilterMandatory}
          readOnly={readOnly}
        />
        <ScimExpression name={`${name}.scimExpression`} filters={filters} />
      </div>
    ),
    [filters, name, firstFilterMandatory, variables, readOnly]
  )
}

Audience.displayName = 'Audience'

const Filters = withFieldArray(
  ({ name, value: filters, helper, variables, firstFilterMandatory, readOnly = false }: any) => {
    let filterStyle = ''
    return (
      <div className="border-b border-gray-200 pb-3 filter">
        {filters.map((filter: any, filterIndex: any) => {
          if (filterIndex !== 0) filterStyle = 'audience-filters'
          return (
            <div key={`filter-${filter.id}`} className={filterStyle}>
              <div className="row filter">
                {(!firstFilterMandatory || filterIndex !== 0) && (
                  <>
                    <div className="row filter-header">
                      <h3 className="text-xs font-bold uppercase">
                        <FormattedMessage {...messages.and} />
                      </h3>
                    </div>
                    {!readOnly && (
                      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                      <div
                        className="row filter-delete"
                        onClick={() => {
                          helper.remove(filterIndex)
                        }}
                      >
                        <p>
                          <FormattedMessage {...messages.filterDelete} />
                        </p>
                        <RemoveCircle className="flex-center" />
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="row filter">
                <Filter
                  renderErrors={false}
                  variables={variables}
                  name={`${name}[${filterIndex}]`}
                  readOnly={readOnly}
                  showCollectionEmailsOption={filters.length === 1}
                />
              </div>
            </div>
          )
        })}
        {!readOnly && filters.some((filter: any) => filter?.attribute?.id !== 'collectionEmails') && (
          <div className="row">
            <AddFilter
              onClick={() => {
                helper.push(newFilter())
              }}
            />
          </div>
        )}
      </div>
    )
  }
)

export default withFieldArray(Audience)
